module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/QR_legales.7a1f9fca.svg";